/**
 * @author Andres Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormualrioBodegasTiposPropiedadesCV from './controladorVista/formularioBodegasTiposPropiedadesCV';
import TablaBodegasTiposPropiedadesCV from './controladorVista/tablaBodegasTiposPropiedadesCV';
import { estadoIncial, reductor } from './reductorBodegasTiposPropiedades';

const BodegasTiposPropiedades: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaBodegasTiposPropiedadesCV />
        <FormualrioBodegasTiposPropiedadesCV />
    </ProveedorEstado>
);

export default BodegasTiposPropiedades;
